import { useEffect, useRef, useState } from 'react';
/**
 * Setup, use and remove event a listener
 *
 * @param {string} eventType Item of type any
 * @param {(e: React.SyntheticEvent) => void} callback Item of type any
 * @param {*} [element=globalThis.window] Item of type any
 * @returns {() => void} Function to explicitly remove the handler early (before the default which is on unmount)
 * @example
 * useEventListener('resize', e => console.log(e));
 */
export var useEventListener = function (eventType, callback, element) {
    if (element === void 0) { element = globalThis.window; }
    var callbackRef = useRef(callback);
    var _a = useState(), remove = _a[0], setRemove = _a[1];
    useEffect(function () {
        callbackRef.current = callback;
    }, [callback]);
    useEffect(function () {
        var handler = function (e) { return callbackRef.current(e); };
        element === null || element === void 0 ? void 0 : element.addEventListener(eventType, handler);
        var remove = function () { return element === null || element === void 0 ? void 0 : element.removeEventListener(eventType, handler); };
        setRemove(function () { return remove; });
        return remove;
    }, [eventType, element]);
    return remove;
};
